import React from 'react'
import get from 'lodash/get'
import GoodsUsageChartTooltipInner from 'widgets/charts/GoodsUsageChartTooltipInner'

export default function GoodsUsageChartTooltip ({ active, payload, ...otherProps }) {
  const innerPayload = get(payload, '0.payload')

  if (!innerPayload) {
    return null
  }

  return (
    <GoodsUsageChartTooltipInner {...innerPayload} />
  )
}
